// extracted by mini-css-extract-plugin
export default {"formGroup":"Checkbox_formGroup__9E68l","formControlLabel":"Checkbox_formControlLabel__6lpyX","icon":"Checkbox_icon__9GKo8","label":"Checkbox_label__5nNBx"};